import React from 'react';

interface IPriceValueProps {
  value?: number;
  currencySymbol?: string;
}

const PriceValue: React.FC<React.PropsWithChildren<IPriceValueProps>> = ({
  value = 0,
  currencySymbol,
}) => {
  return (
    <span>
      {currencySymbol}
      {value.toLocaleString()}
    </span>
  );
};
export default PriceValue;
